angular.module('eficienciaFiscalModule')
    .component('highlighted', {
        transclude: {
            main: 'main',
            secondary: '?secondary'
        },
        controller: ['$transclude', function($transclude) {
            this.hasSubHeader = $transclude.isSlotFilled('sub')
        }],
        template: `
            <h1 style="text-align: center; margin: 60px 0 60px">
                <div ng-transclude="main"></div>
                <small ng-transclude="secondary"></small>
            </h1>
        `
    })
